module.exports = __webpack_public_path__ + "static/sca_exemptions4-26aa095a3b22e9ef381f83dc18b0ebd4.png";